module.exports = "<body class=\"fixed-sn deep-purple-skin\">\n  <router-outlet></router-outlet>\n</body>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main